var _circle, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checked",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.466,
    height: 53.466,
    viewBox: "0 0 53.466 53.466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_963",
    "data-name": "Ellipse 963",
    cx: 26.733,
    cy: 26.733,
    r: 26.733,
    transform: "translate(0 0)",
    fill: "#bf6666"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_108731",
    "data-name": "Path 108731",
    d: "M188.8,175.05l14.258,14.2c11.978-2.094,20.542-9.336,22.873-21.783a16.956,16.956,0,0,0,.337-3.105L211.85,152Z",
    transform: "translate(-172.898 -135.977)",
    fill: "#964444"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29021",
    "data-name": "Group 29021",
    transform: "translate(3.981 12.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108733",
    "data-name": "Path 108733",
    d: "M183.838,126.085a3.157,3.157,0,0,1,4.385,0l2.446,2.446a3.157,3.157,0,0,1,0,4.385l-18.553,18.468a3.157,3.157,0,0,1-4.385,0l-2.446-2.446a3.157,3.157,0,0,1,0-4.385Z",
    transform: "translate(-156.051 -125.2)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_29072",
    "data-name": "Group 29072",
    transform: "translate(39.443 3.806) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108733-2",
    "data-name": "Path 108733",
    d: "M183.838,126.085a3.157,3.157,0,0,1,4.385,0l2.446,2.446a3.157,3.157,0,0,1,0,4.385l-18.553,18.468a3.157,3.157,0,0,1-4.385,0l-2.446-2.446a3.157,3.157,0,0,1,0-4.385Z",
    transform: "translate(-156.051 -125.2)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcError);
export default __webpack_public_path__ + "static/media/ic-error.6be91862115e369900d89f4c9f143dd1.svg";
export { ForwardRef as ReactComponent };